<!-- Pass the 'article_detail_page' as a unique identifier for the page -->
<!--<app-popup [page]="'article_detail_page'"></app-popup>--->

<div class="row" *ngIf="articleDetail">
  <div class="col-md mb-4">
    <div class="bg-white rounded-10 custom-shadow overflow-hidden free-picks-blog article-details mb-4" *ngIf="articleDetail.image as image">
      <div class="top-winner-list-item-img position-relative p-1">
        <img [src]="image" [alt]="articleDetail.title" class="img-fluid rounded-10" />
      </div>
      <div class="app-buttons">
        <!-- iOS App Button -->
        <a title="Kingpin Sports Picks App" href="https://kingpin.pro/ios" target="_blank" rel="noopener" class="mx-2">
          <img src="assets/img/button-5.png" alt="Kingpin Sports Picks App" width="183" height="49" />
        </a>
      </div>
      
      <div class="sidebsr-article-details">
        <div class="free-picks-heading px-3 py-2 text-dark">
          <h1 class="fw-bold mb-0 border-start border-primary ps-2">{{ articleDetail.title }}</h1>
        </div>
        <ul class="list-inline px-3">
          <li class="list-inline-item">
            <a [routerLink]="['/', articleDetail.category?.toLowerCase(), articleDetail | UserSlug, 'profile', 'statistics']" class="text-decoration-none d-block">
              <div class="user-img border rounded-circle border-light">
                <img [src]="articleDetail.user_avatar" [alt]="articleDetail.name" class="img-fluid shadow-sm" />
              </div>
            </a>
          </li>
          <li class="list-inline-item">
            <a [routerLink]="['/', articleDetail.category?.toLowerCase(), articleDetail | UserSlug, 'profile', 'statistics']" class="text-decoration-none">
              <div class="free-picks-user-name fw-bold">{{ articleDetail.name | titlecase }}</div>
            </a>
          </li>
          <li class="list-inline-item">
            <small class="text-muted">{{ articleDetail.created_at | date: "medium" }}</small>
          </li>
        </ul>

        <!-- Social Sharing Links -->
        <div class="social-sharing mt-3">
          <div class="button-container">
            <a href="https://www.linkedin.com/shareArticle?url={{currentUrl}}&title={{articleDetail.title}}" target="_blank" class="social-button linkedin">
              Share on LinkedIn
            </a>
            <a href="https://www.facebook.com/sharer/sharer.php?u={{currentUrl}}" target="_blank" class="social-button facebook">
              Share on Facebook
            </a>
            <a href="https://twitter.com/intent/tweet?text={{articleDetail.title}}&url={{currentUrl}}" target="_blank" class="social-button twitter">
              Share on Twitter
            </a>
            <a href="sms:?body={{currentUrl}}" target="_blank" class="social-button imessage">
              Share via iMessage
            </a>
            <a href="https://wa.me/?text={{currentUrl}}" target="_blank" class="social-button whatsapp">
              Share on WhatsApp
            </a>
            <a href="mailto:?subject={{articleDetail.title}}&body={{currentUrl}}" target="_blank" class="social-button email">
              Share via Email
            </a>
          </div>
        </div>

      <div class="article-details-body p-3" [innerHTML]="articleDetail.body"></div>
    </div>
    <div class="mb-4 ng-star-inserted" *ngFor="let user of articleDetail.topusers">
      <div class="row my-kingpin-card overflow-hidden border-0 shadow-sm rounded-10 bg-white mx-0">
        <div class="col-lg-6 col-xxl-3 d-flex card-body text-center position-relative order-1 order-lg-0">
          <div class="kinping-rank-number">#{{ user.rank }}</div>
          <div class="align-self-center w-100">
            <div class="card-top-img-box mb-2">
              <a [routerLink]="['/', articleDetail.category?.toLowerCase(), user | UserSlug, 'profile', 'statistics']">
                <img alt="user" class="card-img-top" [src]="user.user_avatar | baseUrl" />
              </a>
            </div>
            <div class="fw-bold text-f14">
              <a class="text-dark" [routerLink]="['/', articleDetail.category?.toLowerCase(), user | UserSlug, 'profile', 'statistics']">
                {{ user.name }}
              </a>
            </div>
            <ul class="list-inline">
              <li class="list-inline-item">
                <small class="card-text text-muted">
                  <i class="fas fa-map-marker-alt me-2"></i>
                  {{ user.city }}
                </small>
              </li>
              <li class="list-inline-item">|</li>
              <li class="list-inline-item">
                <a [routerLink]="['/', articleDetail.category?.toLowerCase(), user | UserSlug, 'profile', 'upcoming-picks']">
                  <span class="badge bg-warning text-dark small">{{ user.upcomingbets }} Upcoming Picks</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6 col-xxl-3 align-self-center card-body border-0 card-details py-0 py-lg-3 order-2 order-lg-1">
          <div class="card-details-item mb-2">
            Winnings
            <span class="float-end float-lg-none d-lg-block float-xl-end fw-bold" [class.text-danger]="user.total_winnings < 0" [class.text-success]="user.total_winnings > 0">
              {{ user.total_winnings | CustomCurrency }}
            </span>
          </div>
          <div class="card-details-item mb-2">
            last 30 days winnings
            <span class="float-end float-lg-none d-lg-block float-xl-end fw-bold" [class.text-danger]="user.last_30_days_winnings < 0" [class.text-success]="user.last_30_days_winnings > 0">
              {{ user.last_30_days_winnings | CustomCurrency }}
            </span>
          </div>
          <div class="card-details-item mb-2">
            Yesterday winnings
            <span class="float-end float-lg-none d-lg-block float-xl-end fw-bold" [class.text-danger]="user.last1daysWinnings < 0" [class.text-success]="user.last1daysWinnings > 0">
              {{ user.last1daysWinnings | CustomCurrency }}
            </span>
          </div>
        </div>
        <div class="col-lg-6 col-xxl-3 align-self-center card-body border-0 card-details py-0 py-lg-3 order-3 order-lg-2">
          <div class="card-details-item mb-2">
            Top Sport
            <span class="float-end float-lg-none d-lg-block float-xl-end fw-bold text-dark">{{ user.top_sport }}</span>
          </div>
          <div class="card-details-item mb-2">
            W-L-D
            <span class="float-end float-lg-none d-lg-block float-xl-end fw-bold text-success">{{ user.count_wins }} - {{ user.count_loss }} - {{ user.count_draw }}</span>
          </div>
          <div class="card-details-item mb-2">
            Winnings %
            <span class="float-end float-lg-none d-lg-block float-xl-end fw-bold text-success">{{ user.percent_win }}%</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-auto mb-4 w-md-345" *ngIf="_common.isBrowser">
    <app-top-users></app-top-users>
    <app-upcoming-general></app-upcoming-general>
    <app-article></app-article>
  </div>
</div>
